export function convertNotation(isoToothId: number, notation: 'iso' | 'palmer' | 'universal'): string {
  if (notation === 'iso') return String(isoToothId);

  // Adult quadrants:
  // 1x: UR (Upper Right), 2x: UL (Upper Left), 3x: LL (Lower Left), 4x: LR (Lower Right)
  // Primary quadrants:
  // 5x: UR, 6x: UL, 7x: LL, 8x: LR

  const idStr = String(isoToothId);
  if (idStr.length !== 2) return idStr;

  const quad = parseInt(idStr[0], 10);
  const tooth = parseInt(idStr[1], 10);
  
  if (isNaN(quad) || isNaN(tooth)) return idStr;

  const isPrimary = quad >= 5 && quad <= 8;
  
  if (notation === 'palmer') {
    let quadPrefix = '';
    if (quad === 1 || quad === 5) quadPrefix = 'UR';
    if (quad === 2 || quad === 6) quadPrefix = 'UL';
    if (quad === 3 || quad === 7) quadPrefix = 'LL';
    if (quad === 4 || quad === 8) quadPrefix = 'LR';

    if (isPrimary) {
      // Primary palmer uses letters A-E
      const primaryLetters = ['A', 'B', 'C', 'D', 'E'];
      if (tooth >= 1 && tooth <= 5) {
        return `${quadPrefix}${primaryLetters[tooth - 1]}`;
      }
      return `${quadPrefix}${tooth}`; 
    } else {
      return `${quadPrefix}${tooth}`;
    }
  }

  if (notation === 'universal') {
    // Universal notation
    // Adult: 1-32, starting UR8 (1) to UL8 (16), LL8 (17) to LR8 (32)
    if (!isPrimary) {
      if (quad === 1) return String(9 - tooth); // UR: 18=1, 11=8
      if (quad === 2) return String(8 + tooth); // UL: 21=9, 28=16
      if (quad === 3) return String(25 - tooth); // LL: 38=17, 31=24
      if (quad === 4) return String(24 + tooth); // LR: 41=25, 48=32
    } else {
      // Primary: A-T
      // UR: 55=A, 51=E
      // UL: 61=F, 65=J
      // LL: 75=K, 71=O
      // LR: 81=P, 85=T
      const letters = 'ABCDEFGHIJKLMNOPQRST';
      if (quad === 5) return letters[5 - tooth]; // 55 -> A (index 0), 51 -> E (index 4)
      if (quad === 6) return letters[4 + tooth]; // 61 -> F (index 5), 65 -> J (index 9)
      if (quad === 7) return letters[15 - tooth]; // 75 -> K (index 10), 71 -> O (index 14)
      if (quad === 8) return letters[14 + tooth]; // 81 -> P (index 15), 85 -> T (index 19)
    }
  }

  return idStr;
}
